import fetchCallback from './fetch.js'
import { addLoading } from './lib.js'

const supports = () => {
  return window.history.pushState && window.onpopstate !== undefined
}

const AjaxLoader = ({
  contentSelector = '#Content',
  navSelector = '.AjaxNav',
  root = '/',
} = {}) => {
  if(!supports()) return
  const Content = document.querySelector(contentSelector)
  const [...Menus] = document.querySelectorAll(navSelector)
  const AllLinks = Menus.reduce((acc, menu) => {
    const as = setupMenu(menu, Content, () => AllLinks, root)
    return [...acc, ...as]
  }, [])

  window.addEventListener('popstate', ({ state }) => {
    if (state) {
      const p = location.pathname.slice(root.length)
      loadPage(p, Content, () => AllLinks, root, true)
    }
  })
}

window['AjaxLoader'] = AjaxLoader

const setupMenu = (menu, Content, GetAllLinks, root) => {
  const [...as] = menu.querySelectorAll('a')
  as.forEach((link) => {
    link.addEventListener('click', (e) => {
      e.preventDefault()
      const href = e.currentTarget.getAttribute('href')
      loadPage(href, Content, GetAllLinks, root)
      return false
    })
  })
  return as
}

/**
 * @param {string} page The location of the page to load.
 * @param {Element} Content The element that should be faded out and on top of which the loading indicator will appear.
 * @param {() => Array<Element>} GetAllLinks All the links on the page.
 * @param {string} root The root path of the website.
 */
const loadPage = (page, Content, GetAllLinks, root, skipPushState) => {
  const p = /^\//.test(page) ? page : `/${page}`
  const h = `${root}ajax${p}`
  let placeholder
  let complete
  setTimeout(() => {
    // debounce read from cache
    if (complete) return
    placeholder = addLoading(Content)
  }, 100)
  fetchCallback(h, (err, res) => {
    complete = true
    if (placeholder) {
      document.body.removeChild(placeholder)
    }
    if (err || !res.ok) {
      window.location.href = p
      return
    }
    const { title, content, file } = res.json()
    document.title = title
    Content.innerHTML = content
    stripAndExecuteScript(content)
    if (!skipPushState) history.pushState(true, title, `${root}${page == '/' ? '' : page}`)
    Content.scrollIntoView({ behavior: 'smooth', block: 'start' })
    fixClasses(file, GetAllLinks())
  })
}

/**
 * For all links, update their parent, or their own (when data-self is set) classes to set `Active`. Links need to have `data-file` options to recognise which page they correspond to.
 */
function fixClasses(newFile, links) {
  links.forEach(link => {
    const currentFile = link.getAttribute('data-file')
    const isSelf = link.getAttribute('data-self')
    const target = isSelf ? link : link.parentElement
    if (currentFile != newFile) {
      target.classList.remove('Active')
    } else {
      target.classList.add('Active')
    }
  })
}

// https://stackoverflow.com/questions/2592092/executing-script-elements-inserted-with-innerhtml
function stripAndExecuteScript(text) {
  var scripts = ''
  var modules = []
  var cleaned = text.replace(/<script([^>]*)>([\s\S]*?)<\/script>/gi, function(m, tags, script){
    if (/type="module"/.test(tags)) {
      modules.push(script)
      return
    }
    scripts += script + '\n'
    return ''
  })

  modules.forEach(function(mod) {
    makeScript(mod, true)
  })

  if (window.execScript){
    window.execScript(scripts)
  } else if (scripts) {
    makeScript(scripts)
  }
  return cleaned
}

function makeScript(innerText, mod) {
  var head = document.getElementsByTagName('head')[0]
  var scriptElement = document.createElement('script')
  if (mod) {
    scriptElement.setAttribute('type', 'module')
  } else {
    scriptElement.setAttribute('type', 'text/javascript')
  }
  scriptElement.innerText = innerText
  head.appendChild(scriptElement)
}